/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".blueText[_ngcontent-%COMP%]{color:#005cab;cursor:pointer}.blueTextNoClick[_ngcontent-%COMP%]{color:#005cab}"];
export { styles as styles };
